import { render, staticRenderFns } from "./LimitBanner.vue?vue&type=template&id=80abf3ea&"
import script from "./LimitBanner.vue?vue&type=script&lang=js&"
export * from "./LimitBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports